export default "__VITE_ASSET__CxdJO5ra__"